<template>
  <v-row>
    <v-dialog
      v-model="isSynchronizing"
      :hide-overlay="false"
      :overlay-opacity="0.3"
      persistent
      width="300"
    >
      <v-card
        class="sync-modal"
      >
        <v-card-text
          class="sync-modal__text"
        >
          {{ $t('search.loadings.synchronization') }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name: 'SynchronizingModal',

    props: {
      isSynchronizing: {
        default: false,
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/_config.sass"

  .theme--light.v-card
    background-color: $primary-color

  .v-card__text
    color: #fff !important

  .sync-modal
    height: 100px

    &__text
      padding-top: 30px !important

</style>
